import rootUrl from "../url";

export default rootUrl + "pary/";
